module.exports = __webpack_public_path__ + "media/images/find_us_on_facebook_badge-46aef38613c8589be477a5a49eddafbe.gif";